import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { config } from '@Constants/rx-ui/constants';
import Auth from '@Services/Auth';
import { paths } from '@AppRoutes/constants';
import history from '@AppRoutes/history';
import {
  trackFilterByValue,
  trackRedirectToPreferences,
  trackViewMore,
} from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartFilter/HOCs/analitycs';

const withBarChartFilterHandlers = (Component) => {
  function BarChartFilterHandlersHOC(props) {
    const {
      filter,
      updateFilterUserInputValue,
      isThesaurus,
      openTreeViewDialog,
      openCheckboxesDialog,
      fetchMoreFilterGroups,
      keyifyParamsForFiltersRequest,
      context,
      toggleFilterGroup,
      toggleFilterUserInput,
      openFilterByValueConfirmDialog,
      openLoginPromptDialog,
    } = props;

    const onInputChange = useCallback(
      (value) => {
        updateFilterUserInputValue(filter, value);
      },
      [filter]
    );
    const onClickViewMore = useCallback(() => {
      const filterId = filter.get('id');
      const title = filter.get('title').toLowerCase();
      const groupCount = filter.get('groupCount');

      if (isThesaurus) {
        openTreeViewDialog(filterId, keyifyParamsForFiltersRequest);
        trackViewMore(context, title, 'popup');
        return;
      }

      if (groupCount >= config.FILTER_MAX_GROUP_COUNT) {
        openCheckboxesDialog(filterId, keyifyParamsForFiltersRequest);
        trackViewMore(context, title, 'popup');
        return;
      }

      fetchMoreFilterGroups(filter);
      trackViewMore(context, title, 'expand');
    }, [filter, isThesaurus, keyifyParamsForFiltersRequest, context]);
    const onClickGroup = useCallback(
      (group) => {
        toggleFilterGroup(filter, group);
      },
      [filter]
    );
    const onClickUserInput = useCallback(() => {
      const id = filter.get('id');
      const title = filter.get('title').toLowerCase();
      const userInputOpen = filter.get('userInputOpen');
      const userInputValue = filter.get('userInputValue');

      if (userInputOpen && userInputValue) {
        return openFilterByValueConfirmDialog(id);
      }

      toggleFilterUserInput(filter);
      if (!userInputOpen) {
        trackFilterByValue(context, title);
      }
      return undefined;
    }, [filter]);
    const onRedirectToPreferences = useCallback(() => {
      trackRedirectToPreferences();

      const isAnon = Auth.isAnonymousUser();
      if (isAnon) {
        openLoginPromptDialog();
        return;
      }
      history.push({
        pathname: paths.PROFILE_PREFERENCES,
        state: { openSupplierPreferences: true },
      });
    }, []);

    return (
      <Component
        {...props}
        onInputChange={onInputChange}
        onClickViewMore={onClickViewMore}
        onClickGroup={onClickGroup}
        onClickUserInput={onClickUserInput}
        onRedirectToPreferences={onRedirectToPreferences}
      />
    );
  }

  BarChartFilterHandlersHOC.propTypes = {
    filter: PropTypes.instanceOf(Map),
    updateFilterUserInputValue: PropTypes.func,
    isThesaurus: PropTypes.bool,
    openTreeViewDialog: PropTypes.func,
    openCheckboxesDialog: PropTypes.func,
    fetchMoreFilterGroups: PropTypes.func,
    keyifyParamsForFiltersRequest: PropTypes.string,
    context: PropTypes.string,
    toggleFilterGroup: PropTypes.func,
    toggleFilterUserInput: PropTypes.func,
    openFilterByValueConfirmDialog: PropTypes.func,
    openLoginPromptDialog: PropTypes.func,
  };

  return BarChartFilterHandlersHOC;
};

export default withBarChartFilterHandlers;
